<template>
  <tbody
    :class="`v-table-wrapper-body-${type}-table-tbody`"
  >
  <tr
    :class="`v-table-wrapper-body-${type}-table-tbody-row`"
    v-for="(item, indexRow) in scope.items"
    :row="indexRow"
    :key="'body-' + type + '-' + 'row-' + indexRow"
    ref="row"
  >
    <body-cell-default
      :class="`v-table-wrapper-body-${type}-table-tbody-row-cell`"
      v-for="(column, indexCell) in scope.headers"
      :key="'body-' + type + '-' + 'cell-' + indexCell"
      :cell="indexCell"
      :item="item"
      :column="column"
      :type="type"
    >

      <template
        v-for="(_, slotKey) of $scopedSlots"
        v-slot:[slotKey]="scope"
      >
        <slot :name="slotKey" v-bind="{item: item}"></slot>
      </template>

    </body-cell-default>
  </tr>
  </tbody>
</template>

<script>
  import BodyCellDefault from './BodyCellDefault'

  import { store } from '../store'

  /**
   * для синхронизации высоты строк
   */
  // import ResizeObserver from 'resize-observer-polyfill'
  // const rowSync = new ResizeObserver((entries) => {
  //   for (const entry of entries) {
  //     const {offsetHeight, rowIndex} = entry.target
  //     const ancestor = entry.target.closest('.v-table-wrapper-body')
  //     const otherTable = ancestor.querySelectorAll('.v-table-wrapper-body-fixed-table-tbody-row')
  //     otherTable[rowIndex].style.height = offsetHeight + 'px'
  //   }
  // })

  export default {
    name: 'BodySlot',
    components: {BodyCellDefault},
    props: {
      type: String,
      scope: Object
    },
    methods: {
      createSlotKey (columnValue) {
        return `item.${columnValue}`
      }
    },
    mounted () {
      store.commit('addSortEvents', {index: +(this.type === 'fixed'), func: this.scope.sort})

      /**
       * для синхронизации высоты строк
       */
      // if (this.type === 'common') {
      //   if(Array.isArray(this.$refs.row)) {
      //     this.$refs.row.map((el) => {
      //       rowSync.observe(el)
      //     })
      //   } else rowSync.observe(this.$refs.row)
      // }
    },
    updated () {
      /**
       * для синхронизации высоты строк
       */
      // if (this.type === 'common') {
      //   if(Array.isArray(this.$refs.row)) {
      //     this.$refs.row.map((el) => {
      //       rowSync.observe(el)
      //     })
      //   } else rowSync.observe(this.$refs.row)
      // }
    }
  }
</script>
